import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SuiteConfigSelectionData {
  suiteName: string;
}

@Component({
  selector: 'app-suite-config-selection-dialog',
  templateUrl: './suite-config-selection-dialog.component.html',
  styleUrls: ['./suite-config-selection-dialog.component.scss']
})
export class SuiteConfigSelectionDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SuiteConfigSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SuiteConfigSelectionData
  ) {}

  ngOnInit() {}

  selectDefault() {
    this.dialogRef.close('default');
  }

  selectCustom() {
    this.dialogRef.close('custom');
  }

  cancel() {
    this.dialogRef.close(null);
  }
}

